import { FloatingFormItem } from '@/components/_common';
import { useSpedFileDownload } from '@/core/domain/sped/sped-files/sped-files.hooks';
import {
  SpedFileDownloadType,
  SpedFileDownloadTypeLabels,
} from '@/core/domain/sped/sped-files/sped-files.types';
import { useDisclosure } from '@/hooks';
import { useSpedDocumentContext } from '@/pages/FiscalPages/SpedPage/SpedDocumentsPage/SpedDocumentDetailPage';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import { Button, Form, Modal, Select } from 'antd';

export default function SpedDocumentDownloadFiles() {
  const spedDocument = useSpedDocumentContext();
  const [form] = Form.useForm<{ type: SpedFileDownloadType }>();

  const [open, action] = useDisclosure();

  const hasPermission = hasPermissions([
    Authorities.SPED_DOCUMENT_DOWNLOAD_GENERATE_FILE,
  ]);

  const fileDownload = useSpedFileDownload(spedDocument);

  const download = async () => {
    if (!spedDocument) return;

    const values = await form.validateFields();

    await fileDownload.mutateAsync({
      spedDocumentId: spedDocument.id,
      type: values.type,
    });
  };

  const handleClose = () => {
    form.resetFields();
    action.close();
  };

  return (
    <>
      <Button type="primary" onClick={action.open} disabled={!hasPermission}>
        Baixar arquivo
      </Button>

      <Modal
        title="Tipo de arquivo"
        open={open}
        onCancel={handleClose}
        confirmLoading={fileDownload.isLoading}
        onOk={download}
        okText={fileDownload.isLoading ? 'Baixando...' : 'Baixar arquivo'}
      >
        <p>Selecione o tipo de arquivo a ser baixado</p>

        <Form form={form}>
          <FloatingFormItem
            name="type"
            label="Tipo do documento"
            rules={[{ required: true, message: 'Obrigatório' }]}
            initialValue={SpedFileDownloadType.TAX}
          >
            <Select
              options={Object.keys(SpedFileDownloadTypeLabels).map((key) => ({
                value: key,
                label: SpedFileDownloadTypeLabels[key as SpedFileDownloadType],
              }))}
            />
          </FloatingFormItem>
        </Form>
      </Modal>
    </>
  );
}
